import { useContext, useEffect, useState } from "react";
import TenantProvideDocumentNew from "../../tenant/tenant-home/TenantProvideDocumentNew";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { useParams } from "react-router-dom";
import { haveValue } from "../../../helper/common";
import TenantEmploymentModal from "../../../components/Landlord/created-tenants/TenantEmploymentModal";

const CreatedTenantDocs = () => {
  const { id } = useParams();
  const { setLoading } = useContext(AuthContext);
  const { fetchingCreatedTenant } = useContext(LandLordContext);
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = () => {
    setLoading(true);
    fetchingCreatedTenant(id)
      .then((res) => {
        setLoading(false);
        setUser(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err, "Error inside fetchingCreatedTenant");
      });
  };
  return (
    <>
      {haveValue(user) && (
        <TenantProvideDocumentNew
          llCreated={true}
          user={user}
          setShowModal={setShowModal}
        />
      )}
      {showModal && (
        <TenantEmploymentModal
          id={id}
          user={user}
          setUser={setUser}
          showModal={showModal}
          setShowModal={setShowModal}
          fetchTenantDocs={fetchUserDetails}
        />
      )}
    </>
  );
};

export default CreatedTenantDocs;
